module.exports = __webpack_public_path__ + "ipetbooking/admin/img/hotel.753bcec8.svg";